import { Team__Aliados } from "../teams/Aliados";
import { Team__Cerveceros_MAIN } from "../teams/Cerveceros_MAIN";
import { Team__Chiles } from "../teams/Chiles";
import { Team__MeanMachine } from "../teams/MeanMachine";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__Raptors } from "../teams/Raptors";
import { Team__Tec } from "../teams/Tec";
import { Team__XLobos } from "../teams/XLobos";

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 48,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_MAIN,
  playingPlayers: [],

  goals: 54,
  penaltyGoals: 0,
  isWinner: false,
};

const Chiles = {
  team: Team__Chiles,
  playingPlayers: [],

  goals: 23,
  penaltyGoals: 0,
  isWinner: false,
};

const MeanMachine = {
  team: Team__MeanMachine,
  playingPlayers: [],

  goals: 60,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 53,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 31,
  penaltyGoals: 0,
  isWinner: false,
};

const Tec = {
  team: Team__Tec,
  playingPlayers: [],

  goals: 55,
  penaltyGoals: 0,
  isWinner: false,
};

const XLobos = {
  team: Team__XLobos,
  playingPlayers: [],

  goals: 52,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada2 = {
  jornadaPosition: 2,
  matches: [
    {
      team1: Tec,
      team2: Aliados,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2024-07-30",
      time: "17:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: MeanMachine,
      team2: XLobos,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2024-07-30",
      time: "18:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Chiles,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2024-07-30",
      time: "19:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Nogaleros,
      team2: Raptors,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2024-07-30",
      time: "20:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
